import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals/MoneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import styles from '../EarlyRepayment.module.css';
import messages from './Fees.messages';

const EarlyRepaymentFees = ({
    totalFees,
    isLoading
}: {
    totalFees: number;
    isLoading: boolean;
}) => {
    return (
        <SummaryRow isLoading={isLoading}>
            <FormattedMessage {...messages.fees} />
            <div>
                {getCountry() === 'DE' && (
                    <span className={styles.always}>
                        <FormattedMessage {...messages.always} />
                    </span>
                )}
                <span data-testid="early-repayment-fees">
                    <MoneyWithDecimals value={totalFees} />
                </span>
            </div>
        </SummaryRow>
    );
};

// eslint-disable-next-line import/no-default-export
export default EarlyRepaymentFees;
